import { graphql } from 'react-relay';

import { query, writeQuery } from '@confluence/query-preloader-tools/entry-points/graphql';

import EditContentButtonQuery, {
	type EditContentButtonQuery$data,
	type EditContentButtonQuery$variables,
} from './__generated__/EditContentButtonQuery.graphql';
import type {
	preloadEditButtonWithSpaceKeyQuery$data,
	preloadEditButtonWithSpaceKeyQuery$variables,
} from './__generated__/preloadEditButtonWithSpaceKeyQuery.graphql';

const preloadEditButtonWithSpaceKeyQuery = graphql`
	query preloadEditButtonWithSpaceKeyQuery($spaceKey: String!) {
		space(key: $spaceKey) {
			id
			key
		}
		spaceHomepage(spaceKey: $spaceKey) {
			id
			type
			operations {
				operation
				targetType
			}
			metadata {
				frontend {
					fabricEditorSupported
					embedded
					collabService
				}
			}
			subType
			type
		}
	}
`;

export type preloadEditButtonProps = {
	spaceKey: string;
	contentId?: string;
};

export function preloadEditButton({ spaceKey, contentId = '' }: preloadEditButtonProps) {
	// spaceKey will always be passed for both space overviews and view pages, but contentId is
	// distinct for the latter
	if (spaceKey && !contentId) {
		return query<
			preloadEditButtonWithSpaceKeyQuery$data,
			preloadEditButtonWithSpaceKeyQuery$variables
		>({
			query: preloadEditButtonWithSpaceKeyQuery,
			variables: {
				spaceKey,
			},
		}).then(({ data }) => {
			if (data?.spaceHomepage?.id) {
				writeQuery<EditContentButtonQuery$data, EditContentButtonQuery$variables>({
					query: EditContentButtonQuery,
					variables: {
						contentId: data?.spaceHomepage?.id,
					},
					data: {
						content: data?.spaceHomepage
							? {
									nodes: [
										{
											...data.spaceHomepage,
											space: data?.space || null,
										},
									],
									// @ts-ignore
									__typename: 'PaginatedContentListWithChild',
								}
							: null,
					},
				});
			}
		});
	}
	return query<EditContentButtonQuery$data, EditContentButtonQuery$variables>({
		query: EditContentButtonQuery,
		variables: {
			contentId,
		},
	});
}
